import { render, staticRenderFns } from "./AddPropertyEnquiry.vue?vue&type=template&id=b9bd31c8&"
import script from "./AddPropertyEnquiry.vue?vue&type=script&lang=js&"
export * from "./AddPropertyEnquiry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports